import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { CountrySelectService } from '../../networking/services/country-select/country-select.service';
import { SessionStorageManager } from '../session-storage/session-storage.manager';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CountrySelect } from '../../networking/models/country-select/country-select';

@Injectable({
  providedIn: 'root',
})
export class CountrySelectManager {
  constructor(
    private countrySelectService: CountrySelectService,
    private ssm: SessionStorageManager
  ) { }

  getCountries(): Observable<CountrySelect[]> {
    const cachedFlags = this.ssm.get('flags');

    if( cachedFlags ){
      return of( cachedFlags );
    }else{
      return this.countrySelectService.getCountries().pipe(
        tap(flags => this.ssm.set('flags', flags))
      );
    }
  }

}
